export enum SegmentControlsFilterValueOperators {
  CONTAINS = 'Contains',
  EQUALS = 'Equal'
}
